import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EEntityType, ERelationType } from '@web/dtos';
import { ImageSelectComponent } from '../../../../../components/data-input/form-inputs/image-select/image-select.component';
import { TextInputComponent } from '../../../../../components/data-input/form-inputs/text-input/text-input.component';
import { TranslationAccessibilityTextInputComponent } from '../../../../../components/data-input/form-inputs/translation-accessibility-text-input/translation-accessibility-text-input.component';
import { IFooterBlockForm } from '../../../../../entities/footer-entity';
import { ImageFormsFactoryService } from '../../../../../factory/image/image-forms-factory.service';
import { CmsTextProviderService } from '../../../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-footer-logo-block-editor',
  imports: [
    ReactiveFormsModule,
    ImageSelectComponent,
    TextInputComponent,
    TranslationAccessibilityTextInputComponent,
  ],
  templateUrl: './footer-logo-block-editor.component.html',
})
export class FooterLogoBlockEditorComponent {
  readonly block = input.required<FormGroup<IFooterBlockForm>>();
  readonly index = input.required<number>();

  protected readonly cmsTextProvider = inject(CmsTextProviderService);
  protected readonly EntityType = EEntityType;
  protected readonly TextRelationType = ERelationType;
  private readonly imageFormsFactory = inject(ImageFormsFactoryService);

  protected firstImage() {
    const images = this.block().controls.accessibleImages;
    if (!images.length) {
      images.push(this.imageFormsFactory.buildImageFormGroup(undefined, 0));
    }
    return images.at(0);
  }
}
